"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["allBrands"] = "allBrands";
  TranslationKey["articles"] = "articles";
  TranslationKey["brands"] = "brands";
  TranslationKey["callToActionCatalogueText"] = "callToActionCatalogueText";
  TranslationKey["categories"] = "categories";
  TranslationKey["change"] = "change";
  TranslationKey["clear"] = "clear";
  TranslationKey["clearSearchInput"] = "clearSearchInput";
  TranslationKey["close"] = "close";
  TranslationKey["failedToSubmit"] = "failedToSubmit";
  TranslationKey["favorites"] = "favorites";
  TranslationKey["favouriteLists"] = "favouriteLists";
  TranslationKey["gotIt"] = "gotIt";
  TranslationKey["internationalSponsorGreetings"] = "internationalSponsorGreetings";
  TranslationKey["internationalSponsorMessage"] = "internationalSponsorMessage";
  TranslationKey["loading"] = "loading";
  TranslationKey["logIn"] = "logIn";
  TranslationKey["loggedInAs"] = "loggedInAs";
  TranslationKey["menu"] = "menu";
  TranslationKey["myAccount"] = "myAccount";
  TranslationKey["myFavoriteProducts"] = "myFavoriteProducts";
  TranslationKey["nextCatalogue"] = "nextCatalogue";
  TranslationKey["noOptions"] = "noOptions";
  TranslationKey["notifications"] = "notifications";
  TranslationKey["open"] = "open";
  TranslationKey["oriflameSweden"] = "oriflameSweden";
  TranslationKey["oriflameWallet"] = "oriflameWallet";
  TranslationKey["other"] = "other";
  TranslationKey["popularProducts"] = "popularProducts";
  TranslationKey["popularProductsInThisSearchQuery"] = "popularProductsInThisSearchQuery";
  TranslationKey["popularSearchQueries"] = "popularSearchQueries";
  TranslationKey["popularSearches"] = "popularSearches";
  TranslationKey["products"] = "products";
  TranslationKey["productsX"] = "productsX";
  TranslationKey["quickBuy"] = "quickBuy";
  TranslationKey["recentSearches"] = "recentSearches";
  TranslationKey["register"] = "register";
  TranslationKey["search"] = "search";
  TranslationKey["searchDesktop"] = "searchDesktop";
  TranslationKey["seeAll"] = "seeAll";
  TranslationKey["seeAllCatalogues"] = "seeAllCatalogues";
  TranslationKey["seeAllResultsFor"] = "seeAllResultsFor";
  TranslationKey["shopFor"] = "shopFor";
  TranslationKey["shoppingBag"] = "shoppingBag";
  TranslationKey["showAllResults"] = "showAllResults";
  TranslationKey["signIn"] = "signIn";
  TranslationKey["sponsorGreetings"] = "sponsorGreetings";
  TranslationKey["sponsorMessage"] = "sponsorMessage";
  TranslationKey["suggestions"] = "suggestions";
  TranslationKey["topAreaBannerDialogFallbackMessage"] = "topAreaBannerDialogFallbackMessage";
  TranslationKey["topAreaBannerDialogFallbackTitle"] = "topAreaBannerDialogFallbackTitle";
  TranslationKey["topAreaBannerReferralMessage"] = "topAreaBannerReferralMessage";
  TranslationKey["view"] = "view";
  TranslationKey["viewAll"] = "viewAll";
  TranslationKey["viewWelcomeGiftInformation"] = "viewWelcomeGiftInformation";
  return TranslationKey;
}({});
